import * as queryString from 'query-string';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ISignInErrorScope } from '../../../ts/controllers/SigninErrorCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { Helpers } from '../../../ts/helpers/Helpers';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { LoginUrlsWrapper } from './LoginUrls';

export const AuthErrorTemplate = `<div ng-controller="SignInErrorCtrl" ng-include="'errorSignin.html'"></div>`;

export interface SpaceRouteParams {
  readonly errorCode: string;
}
export interface SigninErrorRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface LoginErrorProviderProps extends ReactDirectiveProps {
  readonly isSessionMultiSite: boolean;
  readonly urls: SpacesSiteUrls;
}

export class LoginErrorProvider extends React.Component<LoginErrorProviderProps> {
  public render() {
    return (
      <div className="tb-error-box tb-error-no-site">
        <AngularDirective template="<tb:sign-in-logo/>" angularContext={this.props.angularContext} />
        <Route exact path={LoginUrlsWrapper.getInstance().signinErorrCodePath(':errorCode')} render={this.errorCodeProvider()} />
        <Route exact path={LoginUrlsWrapper.getInstance().signinAuthErorrPath(':errorCode')} render={this.authErrorProvider()} />
      </div>
    );
  }

  private authErrorProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      return(
        <div>
          <AngularDirective
            angularContext={this.props.angularContext}
            template={AuthErrorTemplate}
            setupScope={(scope) => {
              const childScope = scope.$new() as ISignInErrorScope;
              childScope.errorCode = props.match.params.errorCode;
              childScope.redirectPath = queryValues['redirectPath'];
              return childScope;
            }}
          />
        </div>
      );
    };
  }

  private errorCodeProvider = (): (props: SigninErrorRouteComponentProps) => JSX.Element => {
    return (props: SigninErrorRouteComponentProps): JSX.Element => {
      const queryValues = queryString.parse(props.location.search);
      const errorCode = props.match.params.errorCode;
      const fromSiteSwitch = Helpers.BooleanQueryParamRegex.test(queryValues['fromSiteSwitch']);
      if (fromSiteSwitch) {
        if (this.props.isSessionMultiSite) {
          return <RouterError code={errorCode} errorType="no-site-multi-site-user" urls={this.props.urls}/>;
        } else {
          return <RouterError code={errorCode} errorType="no-site-single-site-user" urls={this.props.urls}/>;
        }
      } else {
        return <RouterError code={errorCode} errorType="code" urls={this.props.urls}/>;
      }
    };
  }
}
